class PremiumBrandStory extends HTMLElement {
  connectedCallback() {
    this.classList.add('is-reveal-ready');
    this.visual = this.querySelector('[data-pbst-visual]');
    this.stage = this.querySelector('[data-pbst-stage]');
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    this.addEventListener('pointerdown', this.onPointerDown);
    this.visual?.addEventListener('pointermove', this.onVisualPointerMove);
    this.visual?.addEventListener('pointerleave', this.resetVisualTilt);
    this.setupObserver();
  }

  disconnectedCallback() {
    this.removeEventListener('pointerdown', this.onPointerDown);
    this.visual?.removeEventListener('pointermove', this.onVisualPointerMove);
    this.visual?.removeEventListener('pointerleave', this.resetVisualTilt);
    this.observer?.disconnect();
    cancelAnimationFrame(this.tiltFrame);
    clearTimeout(this.clickTimer);
  }

  onPointerDown = (event) => {
    const interactive = event.target.closest('[data-pbst-interactive]');

    if (interactive && this.contains(interactive)) {
      this.animateInteractive(interactive, event);
      return;
    }

    const visual = event.target.closest('[data-pbst-visual]');
    if (!visual || !this.contains(visual)) return;

    visual.classList.remove('is-clicked');
    requestAnimationFrame(() => visual.classList.add('is-clicked'));
    clearTimeout(this.clickTimer);
    this.clickTimer = setTimeout(() => visual.classList.remove('is-clicked'), 560);
  };

  animateInteractive(element, event) {
    element.classList.remove('is-clicked');
    requestAnimationFrame(() => element.classList.add('is-clicked'));
    setTimeout(() => element.classList.remove('is-clicked'), 500);

    const ripple = element.querySelector('[data-pbst-ripple]');
    if (!ripple || this.reducedMotion.matches) return;

    const rect = element.getBoundingClientRect();
    ripple.style.left = event.clientX - rect.left + 'px';
    ripple.style.top = event.clientY - rect.top + 'px';
    ripple.classList.remove('is-active');
    requestAnimationFrame(() => ripple.classList.add('is-active'));
    ripple.addEventListener('animationend', () => ripple.classList.remove('is-active'), { once: true });
  }

  onVisualPointerMove = (event) => {
    if (
      this.dataset.enableTilt !== 'true' ||
      this.reducedMotion.matches ||
      !this.finePointer.matches ||
      !this.stage
    ) return;

    const rect = this.visual.getBoundingClientRect();
    const horizontal = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
    const vertical = ((event.clientY - rect.top) / rect.height - 0.5) * 2;

    cancelAnimationFrame(this.tiltFrame);
    this.tiltFrame = requestAnimationFrame(() => {
      this.stage.style.setProperty('--pbst-tilt-x', horizontal * 2.3 + 'deg');
      this.stage.style.setProperty('--pbst-tilt-y', vertical * -2.3 + 'deg');
    });
  };

  resetVisualTilt = () => {
    if (!this.stage) return;
    this.stage.style.setProperty('--pbst-tilt-x', '0deg');
    this.stage.style.setProperty('--pbst-tilt-y', '0deg');
  };

  setupObserver() {
    if (!('IntersectionObserver' in window)) {
      this.classList.add('is-revealed', 'is-in-view');
      return;
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.classList.toggle('is-in-view', entry.isIntersecting);
        if (entry.isIntersecting) this.classList.add('is-revealed');
      },
      { rootMargin: '120px 0px', threshold: 0.06 }
    );
    this.observer.observe(this);
  }
}

if (!customElements.get('premium-brand-story')) {
  customElements.define('premium-brand-story', PremiumBrandStory);
}
